export default "__VITE_ASSET__ae9b0132__"